import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { checkInvAccess } from 'src/app/constants';
@Component({
  selector: 'delete-btn-cell-renderer',
  template: `
    <span class="detailiconhome">
      <img *ngIf="accessEdit"
        class="detailiconhome"
        src="assets/images/icon-delete.svg"
        title="delete"
        alt="Delete"
        style="width=20px;height=20px"
        (click)="btnClickedHandler($event)" 
      />
    </span>
  `,
  // styles: [
  //   `
  //     .detailiconhome {
  //       padding: 0;
  //       margin: 0;
  //     }
  //     .detailiconhome img {
  //       display: block;
  //       margin: 0;
  //       padding: 0;
  //     }
  //   `,
  // ],
})
// <img
      
//         class="img-tool"
//         src="./assets/images/edit.svg"
//         alt="edit button icon"
//         title="Edit"
//       />



export class DeletePctBtnCellRender implements ICellRendererAngularComp {
  pageName: any;
  detailPage: any;
  deleteFlag: boolean = false;
  deleteBtn: any;
  disabled: boolean= false;
  access;
  accessEdit = false;
  constructor(private router: Router, private route: ActivatedRoute, ){}
    refresh(params: ICellRendererParams): boolean {
		return true;
	}

  private params: any;
  agInit(params: any): void {
    // this.access = JSON.parse(localStorage.getItem('shiftAccess1'));
    // this.access1 = JSON.parse(localStorage.getItem('shiftAccess2'));
    // console.log("access",this.access,this.access1)
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;
    this.params = params;     
  }
  btnClickedHandler(event: any) {
    this.params.clicked(this.params.data);
  }

}


